module.exports = __webpack_public_path__ + "static/media/i-11.ea11a7dd.svg";